import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grow from '@material-ui//core/Grow';
import clsx from 'clsx';

import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import Utils from '../../utils/Utils';

const useStyles = makeStyles(theme => ({
    footerContainer: {
        background: 'rgba(0, 0, 0, 0.38)',
        overflow: 'hidden',
    },

    footerContainerItems: {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
        // '@media screen and (max-width: 550px)': {
        //     gridTemplateColumns: '40% 40%',
        // },
    },

    iconContainer: {
        color: '#ddd',
        transition: 'all .2s',
        transform: 'scale(1)',

    },

    socialTabContainer: {
        padding: '10px 0',
        display: 'block',
        textAlign: 'center',
        '&:hover .iconContainer': {
            transform: 'scale(1.3)',
        }
    },

    iconTextContainer: {
        color: '#efefef'
    },

    footerText: {
        color: 'white',
        textAlign: 'center'
    }

}));


const ProductsFooterContainer = (props) => {
    const classes = useStyles();
    const { settings, translations } = props;

    return (
        <div className={classes.footerContainer} data-class="products-footer-container">
            <div className={classes.footerContainerItems}>
                {settings.facebook_page && settings.facebook_page.value ?
                    <div>
                        <a href={'https://www.facebook.com/' + settings.facebook_page.value} target="_blank" rel="noopener noreferrer" className={clsx("text-decoration-none", classes.socialTabContainer)}>
                            <div className={clsx(classes.iconContainer, 'iconContainer')}><FacebookIcon /></div>
                            <div className={classes.iconTextContainer} data-class="each-footer-link-description">{translations.translations && translations.translations.common && translations.translations.common.like_us}</div>
                        </a>
                    </div>
                    :
                    null
                }

                {settings.instagram_page && settings.instagram_page.value ?
                    <div>
                        <a href={'https://www.instagram.com/' + settings.instagram_page.value} target="_blank" rel="noopener noreferrer" className={clsx("text-decoration-none", classes.socialTabContainer)}>
                            <div className={clsx(classes.iconContainer, 'iconContainer')}><InstagramIcon /></div>
                            <div className={classes.iconTextContainer} data-class="each-footer-link-description">{translations.translations && translations.translations.common && translations.translations.common.follow_us}</div>
                        </a>
                    </div>
                    :
                    null
                }

                {settings.youtube_page && settings.youtube_page.value ?
                    <div>
                        <a href={'https://www.youtube.com/' + settings.youtube_page.value} target="_blank" rel="noopener noreferrer" className={clsx("text-decoration-none", classes.socialTabContainer)}>
                            <div className={clsx(classes.iconContainer, 'iconContainer')}><YouTubeIcon /></div>
                            <div className={classes.iconTextContainer} data-class="each-footer-link-description">{translations.translations && translations.translations.common && translations.translations.common.youtube}</div>
                        </a>
                    </div>
                    :
                    null
                }

                {settings.tripadvisor_page && settings.tripadvisor_page.value ?
                    <div>
                        <a href={'https://www.tripadvisor.com/' + settings.tripadvisor_page.value} target="_blank" rel="noopener noreferrer" className={clsx("text-decoration-none", classes.socialTabContainer)}>
                            <div className={clsx(classes.iconContainer, 'iconContainer')}>
                                {Utils.getSettingsValue(settings, 'white_background') == 1 ?
                                    <img src='https://menu.tabl.bg/files/icons/tripadvisor-64.png' width="25" />
                                    :
                                    <img src='https://menu.tabl.bg/files/icons/tripadvisor.png' width="30" />
                                }
                            </div>
                            <div className={classes.iconTextContainer} data-class="each-footer-link-description">{translations.translations && translations.translations.common && translations.translations.common.tipadvisor}</div>
                        </a>
                    </div>
                    :
                    null
                }

            </div>

            {/* footer_html_content is rendered globally in CategoriesHierarchyPage outside SwipeableViews */}
            {/* {settings.footer_html_content && settings.footer_html_content.value ?
                <div data-class="products-footer-text" className={classes.footerText}
                    dangerouslySetInnerHTML={{
                        __html: settings.footer_html_content.value
                    }}>
                </div>
                :
                null
            } */}

        </div>
    );

}

export default ProductsFooterContainer;